import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoDirective } from '@ngneat/transloco';
import { TRANSLATION_SCOPE, translationProvider } from './i18n/translation.provider';

@Component({
  selector: 'rx-applications-password-policy',
  standalone: true,
  imports: [CommonModule, TranslocoDirective],
  templateUrl: './password-policy.component.html',
  providers: [translationProvider],
})
export class PasswordPolicyComponent {
  TRANSLATION_SCOPE = TRANSLATION_SCOPE;
}
